import * as React from "react";

import { reject } from "../TypingUtils";

import { INidusClient, NidusName, NidusReferenceKey } from "./INidusClient";
import { LocalStorageBasedNidusClient } from "./Fakes/LocalStorageBasedNidusClient";
import { IContextualNidusClient } from "./ContextualNidusClient/IContextualNidusClient";
import { ContextualNidusClient } from "./ContextualNidusClient/ContextualNidusClient";

const NidusClientContext = React.createContext<INidusClient | undefined>(undefined);

export function useNidusClient(): INidusClient {
    return React.useContext(NidusClientContext) ?? reject("NidusClient not preset in context");
}

export function useContextualNidusClient(name: NidusName, key: NidusReferenceKey): IContextualNidusClient {
    const nidusClient = useNidusClient();
    return React.useMemo(() => new ContextualNidusClient(nidusClient, name, key), [name, key]);
}

interface NidusClientProviderProps {
    client: INidusClient;
    children: React.ReactNode;
}

export function NidusClientProvider(props: NidusClientProviderProps): JSX.Element {
    const client = React.useMemo(() => props.client ?? new LocalStorageBasedNidusClient(), []);

    return <NidusClientContext.Provider value={client}>{props.children}</NidusClientContext.Provider>;
}
